module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Eksport adresów e-mail do pliku .csv\n    ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "separator",
      "label": "Separator",
      "keys": _vm.keysForSelect,
      "default": _vm.default_separator,
      "options": _vm.separators,
      "placeholder": "Wybierz separator",
      "required": ""
    },
    model: {
      value: (_vm.separator),
      callback: function($$v) {
        _vm.separator = $$v
      },
      expression: "separator"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupa",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "Wybierz grupy które chcesz eksportować"
    },
    model: {
      value: (_vm.email_groups),
      callback: function($$v) {
        _vm.email_groups = $$v
      },
      expression: "email_groups"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "icon": "file_download"
    }
  }, [_vm._v("Eksportuj adresy")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7adc91d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/ExportEmails.vue
// module id = 275
// module chunks = 0